// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__Y1tWa","labelCell":"sales-section_labelCell__SCdyP"};